export interface Doctor {
  id: string;
  name: string;
  specialty: string;
  department: string;
  qualifications: string;
  experience?: string;
  languages?: string[];
  areas: string[];
  initials: string;
  avatarColor: string;
}

export const doctors: Doctor[] = [
  {
    id: "doctor-001",
    name: "Dr. Abhishek Sharma",
    specialty: "Consultant Cosmetic & Plastic Surgeon",
    department: "plastic-surgery",
    qualifications: "Micro-Vascular Surgery (TMC MUMBAI)",
    experience: "19 years",
    languages: ["English", "Hindi"],
    areas: [
      "Cosmetic Surgery",
      "Plastic Surgery",
      "Micro-Vascular Surgery",
      "Reconstructive Procedures",
    ],
    initials: "AS",
    avatarColor: "#6B21D4",
  },
  {
    id: "doctor-002",
    name: "Dr. Pravin R. Borde",
    specialty: "Consultant Neuro and Spine Surgery",
    department: "neuro-spine",
    qualifications: "MS, MCh Neurosurgery",
    experience: "7 years",
    languages: ["English", "Hindi", "Marathi"],
    areas: [
      "Neurosurgery",
      "Spine Surgery",
      "Brain Surgery",
      "Minimally Invasive Spine Procedures",
    ],
    initials: "PB",
    avatarColor: "#0A3D6B",
  },
  {
    id: "doctor-003",
    name: "Dr. Prashant Khairnar",
    specialty: "Consultant Urologist & Andrologist",
    department: "urology",
    qualifications: "MS, MCh Urology",
    experience: "16 years",
    languages: ["English", "Hindi", "Marathi"],
    areas: [
      "Urology",
      "Andrology",
      "Kidney Stone Management",
      "Prostate Disorders",
      "Laparoscopic Urology",
    ],
    initials: "PK",
    avatarColor: "#1A5276",
  },
  {
    id: "doctor-004",
    name: "Dr. Lokendra Singh Thakur",
    specialty: "Interventional Cardiologist",
    department: "cardiology",
    qualifications: "MD, DM Cardiology",
    languages: ["English", "Hindi"],
    areas: [
      "Interventional Cardiology",
      "Coronary Angiography",
      "Angioplasty",
      "Heart Failure Management",
      "Echocardiography",
    ],
    initials: "LT",
    avatarColor: "#922B21",
  },
  {
    id: "doctor-005",
    name: "Dr. Monish Gupta",
    specialty: "Consultant Obstetrician, Gynaecologist & Genetics Specialist",
    department: "gynaecology",
    qualifications: "MD Obstetrics & Gynaecology",
    languages: ["English", "Hindi"],
    areas: [
      "Obstetrics",
      "Gynaecology",
      "Genetics",
      "High-Risk Pregnancy",
      "Laparoscopic Gynaecology",
    ],
    initials: "MG",
    avatarColor: "#7D3C98",
  },
  {
    id: "doctor-006",
    name: "Dr. Ravnik R. Bansod",
    specialty: "Orthopaedic & Joint Replacement Surgeon",
    department: "orthopaedics",
    qualifications:
      "Fellowship in Conventional & Robotics Assisted Joint Replacement Surgery (FRJRS)",
    languages: ["English", "Hindi", "Marathi"],
    areas: [
      "Joint Replacement Surgery",
      "Robotics Assisted Surgery",
      "Knee Replacement",
      "Hip Replacement",
      "Sports Injuries",
    ],
    initials: "RB",
    avatarColor: "#1E8449",
  },
  {
    id: "doctor-007",
    name: "Dr. Divyesh Lad",
    specialty: "General Medicine",
    department: "general-medicine",
    qualifications: "MD General Medicine",
    languages: ["English", "Hindi", "Gujarati"],
    areas: [
      "General Medicine",
      "Fever & Infections",
      "Diabetes Management",
      "Hypertension",
      "Internal Medicine",
    ],
    initials: "DL",
    avatarColor: "#2471A3",
  },
  {
    id: "doctor-008",
    name: "Dr. Gaurav Singh Pardesi",
    specialty: "Consultant General & Minimal Access Surgery",
    department: "general-surgery",
    qualifications: "MS General Surgery",
    languages: ["English", "Hindi"],
    areas: [
      "General Surgery",
      "Laparoscopic Surgery",
      "Minimal Access Surgery",
      "Hernia Repair",
      "Gallbladder Surgery",
    ],
    initials: "GP",
    avatarColor: "#117A65",
  },
  {
    id: "doctor-009",
    name: "Dr. Harshada Bhangale",
    specialty: "Pathologist",
    department: "pathology",
    qualifications: "MD Pathology",
    languages: ["English", "Hindi", "Marathi"],
    areas: [
      "Clinical Pathology",
      "Histopathology",
      "Cytology",
      "Haematology",
      "Microbiology",
    ],
    initials: "HB",
    avatarColor: "#6B21D4",
  },
  {
    id: "doctor-010",
    name: "Dr. Peeyush Suryawanshi",
    specialty: "Consultant Pediatrician & Neonatologist",
    department: "paediatrics",
    qualifications: "MD Paediatrics, Fellowship Neonatology",
    languages: ["English", "Hindi", "Marathi"],
    areas: [
      "Paediatrics",
      "Neonatology",
      "Child Development",
      "Vaccination",
      "NICU Care",
    ],
    initials: "PS",
    avatarColor: "#1A5276",
  },
  {
    id: "doctor-011",
    name: "Dr. Apurva Yadav",
    specialty: "Consultant Ophthalmologist & Cataract Surgeon",
    department: "ophthalmology",
    qualifications: "MS Ophthalmology",
    languages: ["English", "Hindi"],
    areas: [
      "Ophthalmology",
      "Cataract Surgery",
      "Retinal Disorders",
      "Glaucoma",
      "Refractive Surgery",
    ],
    initials: "AY",
    avatarColor: "#0E6655",
  },
  {
    id: "doctor-012",
    name: "Dr. Dilip Patidar",
    specialty: "Consultant Orthopaedic Surgeon",
    department: "orthopaedics",
    qualifications: "MS Orthopaedics",
    experience: "30 years",
    languages: ["English", "Hindi"],
    areas: [
      "Orthopaedic Surgery",
      "Fracture Management",
      "Trauma Surgery",
      "Spine Disorders",
      "Arthroscopy",
    ],
    initials: "DP",
    avatarColor: "#784212",
  },
  {
    id: "doctor-013",
    name: "Dr. Shubham Verma",
    specialty: "Pulmonary Medicine & Critical Care",
    department: "pulmonology",
    qualifications: "MD Pulmonary Medicine",
    languages: ["English", "Hindi"],
    areas: [
      "Pulmonology",
      "Critical Care",
      "Asthma & COPD",
      "Bronchoscopy",
      "Sleep Disorders",
    ],
    initials: "SV",
    avatarColor: "#1B4F72",
  },
  {
    id: "doctor-014",
    name: "Dr. Kimaya Sali Medshikar",
    specialty: "Consultant Obstetrician & Gynaecologist",
    department: "gynaecology",
    qualifications: "MD Obstetrics & Gynaecology",
    languages: ["English", "Hindi", "Marathi"],
    areas: [
      "Obstetrics",
      "Gynaecology",
      "Normal & Caesarean Delivery",
      "Infertility",
      "Menstrual Disorders",
    ],
    initials: "KM",
    avatarColor: "#7D3C98",
  },
  {
    id: "doctor-015",
    name: "Dr. Pranjal Kashiv",
    specialty: "Nephrology & Transplant Immunology",
    department: "nephrology",
    qualifications: "DM Nephrology",
    languages: ["English", "Hindi"],
    areas: [
      "Nephrology",
      "Transplant Immunology",
      "Chronic Kidney Disease",
      "Dialysis",
      "Kidney Transplant",
    ],
    initials: "PK",
    avatarColor: "#0B5345",
  },
  {
    id: "doctor-016",
    name: "Dr. Madhur M. Maniyar",
    specialty: "Internal Medicine & Nephrology",
    department: "nephrology",
    qualifications: "MD Internal Medicine, DM Nephrology",
    languages: ["English", "Hindi"],
    areas: [
      "Internal Medicine",
      "Nephrology",
      "Hypertension",
      "Electrolyte Disorders",
      "Acute Kidney Injury",
    ],
    initials: "MM",
    avatarColor: "#1F618D",
  },
  {
    id: "doctor-017",
    name: "Dr. Kapil Chourasiya",
    specialty: "Clinical Nutrition & Dietetics",
    department: "nutrition",
    qualifications: "MSc Clinical Nutrition & Dietetics",
    languages: ["English", "Hindi"],
    areas: [
      "Clinical Nutrition",
      "Dietetics",
      "Diabetes Diet Management",
      "Therapeutic Nutrition",
      "Weight Management",
    ],
    initials: "KC",
    avatarColor: "#1E8449",
  },
  {
    id: "doctor-018",
    name: "Dr. Rashi Gupta",
    specialty: "Consultant Pathologist",
    department: "pathology",
    qualifications: "MD Pathology",
    languages: ["English", "Hindi", "Marathi"],
    areas: [
      "Pathology",
      "Histopathology",
      "Cytopathology",
      "Haematology",
      "Clinical Laboratory",
    ],
    initials: "RG",
    avatarColor: "#6B21D4",
  },
  {
    id: "doctor-019",
    name: "Dr. Shweta Narwade",
    specialty: "Consultant Radiologist",
    department: "radiology",
    qualifications: "MD Radiology",
    languages: ["English", "Hindi", "Marathi"],
    areas: [
      "Radiology",
      "Diagnostic Imaging",
      "Ultrasound",
      "CT Scan",
      "MRI Interpretation",
    ],
    initials: "SN",
    avatarColor: "#2C3E50",
  },
  {
    id: "doctor-020",
    name: "Dr. Nikhil Tharkade",
    specialty: "Consultant Urologist",
    department: "urology",
    qualifications: "MCh Urology",
    languages: ["English", "Hindi"],
    areas: [
      "Urology",
      "Urological Surgery",
      "Kidney Disorders",
      "Bladder Conditions",
      "Male Reproductive Health",
    ],
    initials: "NT",
    avatarColor: "#1A5276",
  },
];

export const getDoctorById = (id: string): Doctor | undefined =>
  doctors.find((d) => d.id === id);

export const getDoctorsByDepartment = (departmentId: string): Doctor[] =>
  doctors.filter((d) => d.department === departmentId);